export default "__VITE_ASSET__BaeaB9jH__"